import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import paynetLogo from '../../Images/paynet_logo.png';
import Paper from '@material-ui/core/Paper';
import visaLogo from '../../Images/payment_provider_images/visa.svg';
import mcLogo from '../../Images/payment_provider_images/mc.svg';
import CurrencySelector from './CurrencySelector';


export default function PaynetConfiguration(props) {
  const globalContext = useContext(GlobalContext);
  const classes = useStyles();
  const [accountConnected, setAccountConnected] = useState(false);
  const [connectedAccountId, setConnectedAccountId] = useState('');


  useEffect(
    () => {
      
      //window.gtag('config', 'UA-160225157-2', { 'page_path': '/PaynetConfiguration' });
      
      globalContext.dispatchMethod(
        {
          type: 'SET_MENU_LOCATION',
          value: {
            a: 8,
            b: 112,
          },
        }
      )


    }, []
  )


  return (
    <div className={classes.root}>
      {
        1==2 ?
        <CurrencySelector></CurrencySelector>
        :
        null
      }
      
      <Paper elevation={3} style={{ padding: '10px', margin: '30px 0' }}>
        <div>
          <div className="powered-by-stripe-container">
            <img src={paynetLogo} style={{ width: '150px' }}></img>
          </div>
          <br></br>
          {
            accountConnected ?
              <p> You are connected and your Stripe account ID is:<b> {connectedAccountId}</b></p>
              :
              <React.Fragment>
                <p>
                  Paynet ile işletmeniz adına tüm banka kartlarından tahsilat yapabilirsiniz. Bunun için tek yapmanız gereken aşağıdaki linkte yer alan başvuru formunu doldurmak. Başvurunuzun onaylanmasının ardından HappyTable üzerinden ödeme kabul etmeye başlayabilirsiniz.
        </p>
                <br></br>
                <br></br>
                <div>

                  <a href="https://paynet.com.tr" target="_blank" style={{ fontSize: '1.3rem' }}>Paynet başvuru</a>
                </div>
              </React.Fragment>
          }

        </div>

      </Paper>

    </div>
  )
}

const useStyles = makeStyles({
  root: {
  }
});